import React, { useState, useEffect } from "react";
import Navbar from "../layout/Navbar";
import Rectangle from "../assets/Rectangle.png";
import Frame from "../assets/Frame.png";
import Footer from "../layout/Footer";
import { Eye } from "lucide-react";
import { Link } from "react-router-dom";

const PatientPortal = () => {
    const [openSection, setOpenSection] = useState(null);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [showPatientModal, setShowPatientModal] = useState(false);
    const [timer, setTimer] = useState(15);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [selectedPatient, setSelectedPatient] = useState(null);

    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };

    const handleContinueClick = () => {
        setShowOtpModal(true);
        setTimer(15);
    };

    const handleLogout = () => {
        setIsLoggedIn(false);
        setSelectedPatient(null);
    };

    useEffect(() => {
        if (showOtpModal && timer > 0) {
            const countdown = setTimeout(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
            return () => clearTimeout(countdown);
        }
    }, [showOtpModal, timer]);

    const patients = [
        {
            id: 1,
            name: "Miss Samikshya Sukhla",
            mrn: "MRN91912727621",
            image: "https://i.imgur.com/dl6WNea.png",
            active: true,
            gender: "Female",
            dob: "23 Dec 1996 (28 yrs)",
            registeredOn: "01 Feb 2022, 21:25",
        },
        {
            id: 2,
            name: "Mr Ranjan Sukhla",
            mrn: "MRN18128812813",
            image: "https://i.imgur.com/UL6ZxXl.png",
            active: false,
            gender: "Male",
            dob: "15 Jun 1980 (44 yrs)",
            registeredOn: "05 Mar 2022, 14:35",
        },
        {
            id: 3,
            name: "Mr Sanjay Sukhla",
            mrn: "MRN18128812814",
            active: false,
            gender: "Male",
            dob: "10 Oct 1975 (49 yrs)",
            registeredOn: "12 Apr 2022, 09:15",
        },
    ];

    const handleSelectPatient = (patient) => {
        setSelectedPatient(patient);
        setIsLoggedIn(true);
        setShowPatientModal(false);
    };

    if (isLoggedIn && selectedPatient) {
        return (
            <div className="min-h-screen bg-gray-50">
                <Navbar />
                {/* My Wellness Space Header */}
                <div className="bg-white border-b border-gray-200">
                    <div className="container px-4 py-2 mx-auto">
                        <h1 className="text-xl font-medium text-gray-700">
                            My Wellness Space
                        </h1>
                    </div>
                </div>

                {/* Patient Info Card */}
                <div
                    className="container px-4 py-4 mx-auto"
                    style={{
                        backgroundImage: Frame,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: "12px",
                    }}
                >
                    <div className="p-3 rounded-lg bg-gradient-to-r from-teal-500 to-purple-500 bg-opacity-90 backdrop-blur-sm">
                        <div className="flex items-center">
                            <div className="flex-shrink-0">
                                <img
                                    src={
                                        selectedPatient.image ||
                                        "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                                    }
                                    alt={selectedPatient.name}
                                    className="object-cover w-20 h-20 rounded-md"
                                />
                            </div>
                            <div className="flex-1 ml-4">
                                <div className="flex items-start justify-between">
                                    <div>
                                        <h2 className="text-lg font-semibold text-white">
                                            {selectedPatient.name}
                                        </h2>
                                        <div className="mt-1 text-sm text-white/90">
                                            <p>
                                                <span className="font-medium">
                                                    MRN:
                                                </span>{" "}
                                                {selectedPatient.mrn}
                                            </p>
                                            <p>
                                                <span className="font-medium">
                                                    Gender:
                                                </span>{" "}
                                                {selectedPatient.gender}
                                            </p>
                                            <p>
                                                <span className="font-medium">
                                                    Date of Birth:
                                                </span>{" "}
                                                {selectedPatient.dob}
                                            </p>
                                            <p>
                                                <span className="font-medium">
                                                    Registered on:
                                                </span>{" "}
                                                {selectedPatient.registeredOn}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex space-x-3">
                                        <button className="flex items-center px-4 py-2 text-white transition border border-2 border-white rounded-xl backdrop-blur-sm">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={1.5}
                                                stroke="currentColor"
                                                className="w-4 h-4 mr-1"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
                                                />
                                            </svg>
                                            Switch Patient
                                        </button>
                                        <button className="flex items-center px-3 py-1 text-white transition border border-2 border-white rounded-xl backdrop-blur-sm">
                                            <Eye className="h-5" />
                                            View Profile
                                        </button>
                                        <button
                                            onClick={handleLogout}
                                            className="flex items-center px-3 py-1 text-white transition border border-2 border-white rounded-xl backdrop-blur-sm"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={1.5}
                                                stroke="currentColor"
                                                className="w-4 h-4 mr-1"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                                                />
                                            </svg>
                                            Logout
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Services Grid */}
                <div className="container px-4 py-6 mx-auto">
                    <div className="grid grid-cols-3 gap-4 sm:grid-cols-4 md:grid-cols-7">
                        <div className="flex flex-col items-center justify-center p-4 transition bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md">
                            <Link to="/appointment">
                            <div className="flex items-center justify-center w-12 h-12 mb-2 text-pink-500 bg-pink-100 rounded-full">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
                                    />
                                </svg>
                            </div>
                            
                            <span className="text-xs font-medium text-center text-gray-700">
                                Appointment
                            </span>
                            </Link>
                        </div>

                        <div className="flex flex-col items-center justify-center p-4 transition bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md">
                            <div className="flex items-center justify-center w-12 h-12 mb-2 text-pink-500 bg-pink-100 rounded-full">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75"
                                    />
                                </svg>
                            </div>
                            <span className="text-xs font-medium text-center text-gray-700">
                                Health Checkup
                            </span>
                        </div>

                        <div className="flex flex-col items-center justify-center p-4 transition bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md">
                            <Link to="/prescriptions">
                            <div className="flex items-center justify-center w-12 h-12 mb-2 text-pink-500 bg-pink-100 rounded-full">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
                                    />
                                </svg>
                            </div>
                            <span className="text-xs font-medium text-center text-gray-700">
                                Prescriptions
                            </span>
                            </Link>
                        </div>

                        <div className="flex flex-col items-center justify-center p-4 transition bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md">
                            <Link to="/lab-report">
                            <div className="flex items-center justify-center w-12 h-12 mb-2 text-pink-500 bg-pink-100 rounded-full">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                                    />
                                </svg>
                            </div>
                            <span className="text-xs font-medium text-center text-gray-700">
                                Lab Reports
                            </span>
                            </Link>
                        </div>

                        <div className="flex flex-col items-center justify-center p-4 transition bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md">
                            <div className="flex items-center justify-center w-12 h-12 mb-2 text-pink-500 bg-pink-100 rounded-full">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125z"
                                    />
                                </svg>
                            </div>
                            <span className="text-xs font-medium text-center text-gray-700">
                                Radiology Reports
                            </span>
                        </div>

                        <div className="flex flex-col items-center justify-center p-4 transition bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md">
                            <div className="flex items-center justify-center w-12 h-12 mb-2 text-pink-500 bg-pink-100 rounded-full">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                                    />
                                </svg>
                            </div>
                            <span className="text-xs font-medium text-center text-gray-700">
                                Admissions
                            </span>
                        </div>

                        <div className="flex flex-col items-center justify-center p-4 transition bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md">
                            <div className="flex items-center justify-center w-12 h-12 mb-2 text-pink-500 bg-pink-100 rounded-full">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9.75m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75m8.25-3l-3 3m0 0l-3-3m3 3V3.375c0-.621-.504-1.125-1.125-1.125h-.375M3.75 4.5c-.621 0-1.125.504-1.125 1.125v9.75c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H3.75z"
                                    />
                                </svg>
                            </div>
                            <span className="text-xs font-medium text-center text-gray-700">
                                Bills & Payments
                            </span>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        );
    }

    return (
        <div>
            <Navbar />

            {/* Hero Section */}
            <div
                className="relative h-[700px] bg-cover bg-center"
                style={{ backgroundImage: `url(${Rectangle})` }}
            >
                {/* Heading */}
                <div className="absolute space-y-2 top-16 left-6 md:left-16">
                    <h2 className="text-5xl font-bold text-white md:text-6xl drop-shadow-md">
                        Patient Portal
                    </h2>
                    <h2 className="text-2xl font-semibold text-white md:text-3xl drop-shadow-sm">
                        Take Control of Your
                    </h2>
                    <h2 className="text-2xl md:text-3xl font-semibold text-white bg-[#C86DBA] inline-block px-3 py-1 rounded">
                        Health Journey
                    </h2>
                </div>

                {/* Login Box */}
                <div className="absolute bottom-10 left-6 md:left-16 backdrop-blur-md bg-white/80 p-6 rounded-xl shadow-lg w-[360px]">
                    <h3 className="text-2xl font-semibold text-center mb-4 text-[#009DA5]">
                        Patient Login
                    </h3>

                    <input
                        type="text"
                        placeholder="Enter MRN or Mobile Number"
                        className="w-full p-3 mb-4 border border-gray-400 h-12 rounded-md focus:outline-none focus:ring-2 focus:ring-[#009DA5]"
                    />

                    <button
                        onClick={handleContinueClick}
                        className="w-full bg-[#009DA5] text-white py-3 rounded-md hover:bg-[#007B85] transition"
                    >
                        Continue
                    </button>

                    <p className="mt-3 text-sm text-center text-gray-700">
                        Not registered yet?{" "}
                        <span className="text-[#009DA5] cursor-pointer hover:underline">
                            Register Now
                        </span>
                    </p>
                </div>

                {/* OTP Modal */}
                {showOtpModal && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                        <div className="bg-white p-6 rounded-3xl shadow-xl w-[360px] backdrop-blur-md">
                            <h3 className="text-xl font-semibold text-[#009DA5] mb-2 text-center">
                                Verify OTP
                            </h3>
                            <p className="mb-4 text-sm text-center text-gray-700">
                                Enter the OTP sent to your registered mobile
                                number (+91) xxxxxx8862
                            </p>

                            <input
                                type="text"
                                placeholder="Enter OTP"
                                className="w-full p-3 mb-3 border border-gray-400 h-12 rounded-md focus:outline-none focus:ring-2 focus:ring-[#009DA5]"
                            />

                            <p className="mb-4 text-sm text-center text-red-500">
                                {timer > 0
                                    ? `OTP will expire in ${timer}s`
                                    : "OTP expired. Please resend."}
                            </p>

                            <div className="flex flex-col gap-3">
                                <button
                                    className="w-full bg-[#009DA5] text-white py-2 rounded-md hover:bg-[#007B85] transition"
                                    onClick={() => {
                                        setShowOtpModal(false);
                                        setShowPatientModal(true);
                                    }}
                                >
                                    Verify
                                </button>
                                <button
                                    onClick={() => setShowOtpModal(false)}
                                    className="w-full py-2 text-gray-800 transition bg-gray-300 rounded-md hover:bg-gray-400"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Patient Modal */}
                {showPatientModal && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                        <div className="bg-white w-[360px] p-6 rounded-3xl shadow-xl space-y-4">
                            <h2 className="text-2xl font-semibold text-center text-[#005961]">
                                Select Patient
                            </h2>
                            <p className="text-sm text-center text-gray-600">
                                We found multiple patient associated with this
                                phone number. Please select a patient.
                            </p>

                            <div className="space-y-3">
                                {patients.map((patient, idx) => (
                                    <div
                                        key={idx}
                                        onClick={() =>
                                            handleSelectPatient(patient)
                                        }
                                        className={`flex items-center gap-4 p-3 rounded-lg cursor-pointer border ${
                                            patient.active
                                                ? "bg-[#E6F7F8] border-[#009DA5]"
                                                : "bg-gray-100 border-transparent"
                                        }`}
                                    >
                                        <img
                                            src={
                                                patient.image ||
                                                "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                                            }
                                            alt="Patient"
                                            className="object-cover w-10 h-10 rounded-full"
                                        />
                                        <div>
                                            <p
                                                className={`text-sm font-medium ${
                                                    patient.active
                                                        ? "text-[#009DA5]"
                                                        : "text-gray-800"
                                                }`}
                                            >
                                                {patient.name}
                                            </p>
                                            <p className="text-xs text-gray-500">
                                                {patient.mrn}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* E-Help Desk */}
            <div className="bg-[#F9F9F9] py-10 px-4 md:px-20">
                <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-[#009DA5]">
                    <span className="text-[#009DA5] font-bold">E-Help</span>{" "}
                    Desk
                </h2>

                <div className="bg-white rounded-lg shadow-sm">
                    {/* Patient Guide */}
                    <div
                        className="flex items-center justify-between px-6 py-4 transition border-b cursor-pointer hover:bg-gray-50"
                        onClick={() => toggleSection("patient")}
                    >
                        <span className="font-medium text-gray-800">
                            Patient Guide
                        </span>
                        <span>{openSection === "patient" ? "▲" : "▼"}</span>
                    </div>
                    {openSection === "patient" && (
                        <div className="px-6 py-4 text-sm text-gray-600">
                            Here you can add patient-related instructions or
                            downloadable files.
                        </div>
                    )}

                    {/* Visitor Guide */}
                    <div
                        className="flex items-center justify-between px-6 py-4 transition cursor-pointer hover:bg-gray-50"
                        onClick={() => toggleSection("visitor")}
                    >
                        <span className="font-medium text-gray-800">
                            Visitor Guide
                        </span>
                        <span>{openSection === "visitor" ? "▲" : "▼"}</span>
                    </div>
                    {openSection === "visitor" && (
                        <div className="px-6 py-4 text-sm text-gray-600">
                            Here you can add visitor-related details, timings,
                            or rules.
                        </div>
                    )}
                </div>

                <p className="mt-6 text-sm text-center text-gray-600">
                    For further assistance call at{" "}
                    <span className="text-[#C86DBA] font-medium">
                        +91 9909021667
                    </span>
                </p>
            </div>

            <Footer />
        </div>
    );
};

export default PatientPortal;
